export default __webpack_public_path__ + "static/bg_header_pc-2bb8091c90eeeda157ffa9e5c340b9b5.png";